import { useState } from "react";
import styles from "./styles/faq";
import { withTranslation } from "../../i18n";
import { faqQuestionData } from "../../static/new-landing-page/new-landing-data";

const FAQ = ({ t, i18n }) => {
    const language = i18n.language
    const faqData = faqQuestionData[language] || faqQuestionData.en
    const classes = styles();
    const [openIndex, setOpenIndex] = useState(0);


    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? -1 : index);
    };

    return (
        <div className={classes.root}>
            <div className={classes.leftSection}>
                <h2 className={classes.title}>
                    {t("faq-title")}
                </h2>
            </div>
            <div className={classes.rightSection}>
                <div className={classes.faqContainer}>
                    {faqData.map((faq, index) => (
                        <div key={index} className={classes.faqItem}>
                            <div
                                className={classes.faqHeader}
                                onClick={() => toggleFAQ(index)}
                            >
                                <div className={classes.questionIcon}>
                                    <span>?</span>
                                </div>
                                <div className={`${classes.questionText} ${openIndex === index ? classes.txtWhite : ''}`}>
                                    {faq.question}
                                </div>
                                <div className={classes.chevronIcon}>
                                    {openIndex === index ? (
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M18 15L12 9L6 15" stroke="#403DE3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    ) : (
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M6 9L12 15L18 9" stroke="#403DE3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    )}
                                </div>
                            </div>
                            {/* Every answer stays in the HTML so crawlers and AI answer engines can read it;
                                the closed ones are hidden with inline display:none, which looks the same as not rendering them. */}
                            <div
                                className={classes.faqAnswer}
                                style={openIndex === index ? undefined : { display: "none" }}
                                aria-hidden={openIndex === index ? undefined : "true"}
                            >
                                {faq.answer}
                                {faq.answerLink && (
                                    <a
                                        href={faq.answerLinkUrl || "/page/refund-policy"}
                                        className={classes.faqLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {faq.answerLink}
                                    </a>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default withTranslation(["myfitsociety"])(FAQ);
